import { createPortal } from 'react-dom';
import { Icon } from '@/components/Icon';
import { useMenuPortal } from '@/hooks/useMenuPortal';

/**
 * Три точки у плитки шаблона — редактирование/удаление/установка по
 * умолчанию (1:1 DropDown в OperatorListLayout::columns() старого Orchid).
 * Дропдаун — порталом в body (см. useMenuPortal), чтобы не обрезался плиткой
 * и не добавлял ей прокрутку.
 */
export function OperatorTemplateMenu({
  disabled,
  isDefault,
  onEdit,
  onDelete,
  onSetDefault,
}: {
  disabled: boolean;
  isDefault: boolean;
  onEdit: () => void;
  onDelete: () => void;
  onSetDefault: () => void;
}) {
  const { open, coords, triggerRef, dropdownRef, toggle, run } = useMenuPortal(3);

  return (
    <div className="row-menu">
      <button
        ref={triggerRef}
        type="button"
        className="row-menu__trigger"
        aria-label="Действия"
        onClick={toggle}
        disabled={disabled}
      >
        <Icon name="kebab" size={16} />
      </button>
      {open &&
        coords &&
        createPortal(
          <div
            className="row-menu__dropdown"
            style={{ top: coords.top, bottom: coords.bottom, right: coords.right }}
            ref={dropdownRef}
          >
            <button type="button" className="row-menu__item" onClick={() => run(onEdit)}>
              <Icon name="pencil" size={15} /> Редактировать
            </button>
            {/* Показываем всегда, а не только для не-дефолтного шаблона: скрытый
                пункт читался как «такой возможности вообще нет». У текущего
                дефолтного он просто неактивен. */}
            <button
              type="button"
              className="row-menu__item"
              disabled={isDefault}
              title={isDefault ? 'Этот шаблон уже используется по умолчанию' : undefined}
              onClick={() => run(onSetDefault)}
            >
              <Icon name="check" size={15} /> {isDefault ? 'Уже по умолчанию' : 'Установить по умолчанию'}
            </button>
            <button
              type="button"
              className="row-menu__item row-menu__item--danger"
              onClick={() => run(onDelete)}
            >
              <Icon name="trash" size={15} /> Удалить
            </button>
          </div>,
          document.body,
        )}
    </div>
  );
}
